import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
//import { surfaceBackgroundNodeFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-image-node-fragment';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const createSurfaceBackgroundNodeMutation = gql`
  mutation createSurfaceBackgroundNode($input: CreateSurfaceBackgroundNodeInput!) {
    createSurfaceBackgroundNode(input: $input) {
      data {
        ...surfaceNodeUnionDetails
      }
      error
      success
    }
  }
  ${surfaceUnionFragment}
`;

export default mutation(createSurfaceBackgroundNodeMutation);
